/**
 * Feature Flags Configuration
 * Centralized configuration for enabling/disabling features across the application
 */

export const FEATURE_FLAGS = {
  /**
   * Enable or disable save functionality across all pages
   * When false, all save buttons and indicators are hidden
   * When true, save functionality is fully enabled
   *
   * Affects:
   * - StartBRRPage: "Save Progress" button
   * - FormPage: "Save" button and save indicator overlay
   * - ConfirmationPage: Inline edit "Save" button
   */
  ENABLE_SAVE_FUNCTIONALITY: true
} as const;
